import RecallVinSearchPageContainer from './RecallVinSearchPageContainer';

export default RecallVinSearchPageContainer;



// WEBPACK FOOTER //
// ./src/components/pages/RecallVinSearchPage/index.js